import $ from 'jquery';
import Immutable from 'immutable';
import BasePropertyTableView from 'BasePropertyTableView.js';
import _template from 'properties/table/column-style-text.ejs';
import { pickerCfg } from 'pickerCfg.js';
import fontService from 'FontService';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';

class StyleTextView extends BasePropertyTableView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');
        this.factoryKey = this.model.get('gridData')[this.colId].attributes['factoryKey'];

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.events = {
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change #textColorPicker': 'updateColorAttributes',
            'change #textColor': 'updateColorAttributesWithValidation',
            'click #boldText, #italicText': 'updateTextStyleAttributes',
            'change #fontFamily, #fontSize, #customFontFamily' : 'updateFontAttributes'
        };

        const map = Immutable.Map([
            ['textInputColumn', 'Text'],
            ['dateInputColumn', 'Date'],
            ['textAreaColumn', 'Text'],
            ['numericInputColumn', 'Text'],
            ['timeInputColumn', 'Text'],
            ['dropdownColumn', 'Items'],
            ['fileAttachmentColumn', 'Status']
        ]);

        if (!this.columnModel.attributes['textWeight']) {
            this.columnModel.attributes['textWeight'] = 'normal';
            this.columnModel.attributes['boldSelection'] = this.unselectedColor;
        }

        if (!this.columnModel.attributes['textStyle']) {
            this.columnModel.attributes['textStyle'] = 'normal';
            this.columnModel.attributes['italicSelection'] = this.unselectedColor;
        }

        if (this.columnModel.attributes['textStyle'] === 'italic') {
            this.columnModel.attributes['italicSelection'] = this.selectedColor;
        }

        if (this.columnModel.attributes['textWeight'] === 'bold') {
            this.columnModel.attributes['boldSelection'] = this.selectedColor;
        }

        let currentFont = this.columnModel.get('fontFamily');
        fontService.initCustomFont(this.columnModel, currentFont);

        var headerText = map.get(this.factoryKey);
        this.columnModel.attributes['styleTextSectionHeader'] = headerText;


        return this;
    }

    updateTextStyleAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;

        var weight = this.columnModel.attributes['textWeight'];
        var style = this.columnModel.attributes['textStyle'];

        if (propName === 'textWeight') {
            if (weight.indexOf('bold') > -1) {
                this.columnModel.attributes['boldSelection'] = this.unselectedColor;
                weight = 'normal';
            } else {
                this.columnModel.attributes['boldSelection'] = this.selectedColor;
                weight = 'bold';
            }
        } else if (propName === 'textStyle') {
            if (style.indexOf('italic') > -1) {
                this.columnModel.attributes['italicSelection'] = this.unselectedColor;
                style = 'normal';
            } else {
                this.columnModel.attributes['italicSelection'] = this.selectedColor;
                style = 'italic';
            }
        }

        this.columnModel.attributes['textWeight'] = weight;
        this.columnModel.attributes['textStyle'] = style;
        // this.model.trigger('change', this.model);
        this.render();

        // PF-5745
        undoService.add({
            undo: () =>{
                if (propName === 'textWeight') {
                    if (weight.indexOf('bold') > -1) {
                        this.columnModel.attributes['boldSelection'] = this.unselectedColor;
                        weight = 'normal';
                    } else {
                        this.columnModel.attributes['boldSelection'] = this.selectedColor;
                        weight = 'bold';
                    }
                } else if (propName === 'textStyle') {
                    if (style.indexOf('italic') > -1) {
                        this.columnModel.attributes['italicSelection'] = this.unselectedColor;
                        style = 'normal';
                    } else {
                        this.columnModel.attributes['italicSelection'] = this.selectedColor;
                        style = 'italic';
                    }
                }
                this.render();
            },
            redo:() => {
                if (propName === 'textWeight') {
                    if (weight.indexOf('bold') > -1) {
                        this.columnModel.attributes['boldSelection'] = this.unselectedColor;
                        weight = 'normal';
                    } else {
                        this.columnModel.attributes['boldSelection'] = this.selectedColor;
                        weight = 'bold';
                    }
                } else if (propName === 'textStyle') {
                    if (style.indexOf('italic') > -1) {
                        this.columnModel.attributes['italicSelection'] = this.unselectedColor;
                        style = 'normal';
                    } else {
                        this.columnModel.attributes['italicSelection'] = this.selectedColor;
                        style = 'italic';
                    }
                }
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE);
    }

    // Delegate to super, so as to impose an override column model parameter -- we are a column view
    updateFontAttributes(ev) {
        let
            propName = ev.currentTarget.name,
            propVal = ev.currentTarget.value;

        if(propName === "customFontFamily" || propName === "fontFamily"){
            fontService.updateCustomFont(this.columnModel, propVal);
        }       

        super.updateAttributes(ev, this.model.get('gridData')[this.colId]);

        this.render();
    }

    render() {
        super.render();

        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        const fonts = fontService.loadFontsDropDown(true);
        $("#fontFamily").append(fonts);

        //Set Dropdowns
        if (this.columnModel.attributes['fontFamily']) {
            let fontFamily = this.columnModel.get('fontFamily');
            const customFont = fontService.isCustomFont(fontFamily);
            fontFamily = !customFont ? fontFamily : "__custom__";

            $('#fontFamily')
                .find(`option[value="${fontFamily}"]`)
                .attr(`selected`, true);
        }
        if (this.columnModel.attributes['fontSize']) {
            var ddValue = this.columnModel.attributes['fontSize'];
            var ddl = $('#fontSize');
            ddl.val(ddValue);
        }

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.delegateEvents();
        return this;
    }


}

export default StyleTextView;
